import Layout from "../components/layout/Layout"
import NewsDetailsSection2 from "../components/sections/NewsDetailsSection2"
export default function BlogDetails3() {
	return (
		<>
			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="How To Choose the Right WPC Door Frame ?">
				<NewsDetailsSection2 />
			</Layout>
		</>
	)
}